import './BackToTop.css';

export default function BackToTop() {
  return (
    <a href="#" className="back-to-top" id="backToTop">
      <i className="fas fa-arrow-up"></i>
    </a>
  );
}